module.exports = __webpack_public_path__ + "static/img/z4.5ae9a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/association/z4.png
// module id = pxBQ
// module chunks = 2